import { AiOutlineFileJpg } from "react-icons/ai";
import {
  BsFiletypeBmp,
  BsFiletypeCsv,
  BsFiletypeExe,
  BsFiletypePng,
  BsFiletypeXls,
  BsFiletypeXlsx,
} from "react-icons/bs";
import { FaBan, FaRegFile } from "react-icons/fa";
import {
  MdArrowDropDown,
  MdAttachFile,
  MdCheck,
  MdClose,
  MdEdit,
  MdFormatAlignCenter,
  MdFormatAlignLeft,
  MdFormatAlignRight,
  MdFormatBold,
  MdFormatClear,
  MdFormatIndentDecrease,
  MdFormatItalic,
  MdFormatListBulleted,
  MdFormatListNumbered,
  MdFormatQuote,
  MdFormatUnderlined,
  MdImage,
  MdLink,
  MdLockClock,
  MdOutlineDock,
  MdOutlineEmojiEmotions,
  MdOutlineFolderZip,
  MdOutlineFormatIndentIncrease,
  MdOutlinePictureAsPdf,
  MdPhoto,
  MdRedo,
  MdStrikethroughS,
  MdTextFields,
  MdTextFormat,
  MdUndo,
} from "react-icons/md";
import { RiBallPenFill } from "react-icons/ri";
import { TbBrandGoogleDrive } from "react-icons/tb";

const icons = {
  Undo: MdUndo,
  Redo: MdRedo,
  Bold: MdFormatBold,
  Italic: MdFormatItalic,
  Underline: MdFormatUnderlined,
  Color: MdTextFormat,
  LeftAlign: MdFormatAlignLeft,
  RightAlign: MdFormatAlignRight,
  CenterAlign: MdFormatAlignCenter,
  UnOrderedList: MdFormatListBulleted,
  OrderedList: MdFormatListNumbered,
  IndentLess: MdFormatIndentDecrease,
  IndentMore: MdOutlineFormatIndentIncrease,
  RemoveFormat: MdFormatClear,
  StrikeThrough: MdStrikethroughS,
  CodeQuote: MdFormatQuote,
  DownArrow: MdArrowDropDown,
  Styling: MdTextFormat,
  Attach: MdAttachFile,
  Link: MdLink,
  Image: MdImage,
  Check: MdCheck,
  TextFields: MdTextFields,
  Edit: MdEdit,
  Close: MdClose,
  Emoji: MdOutlineEmojiEmotions,
  InsertImage: MdPhoto,
  LockClock: MdLockClock,
  GoogleDrive: TbBrandGoogleDrive,
  Signature: RiBallPenFill,
  Ban: FaBan,
  Pdf: MdOutlinePictureAsPdf,
  Doc: MdOutlineDock,
  Zip: MdOutlineFolderZip,
  File: FaRegFile,
  Exe: BsFiletypeExe,
  Bmp: BsFiletypeBmp,
  Png: BsFiletypePng,
  Jpg: AiOutlineFileJpg,
  Xsl: BsFiletypeXls,
  Xlsx: BsFiletypeXlsx,
  Csv: BsFiletypeCsv,
};

export default icons;
